import { render, staticRenderFns } from "./confirmDialog.vue?vue&type=template&id=4d47fa45&scoped=true"
import script from "./confirmDialog.vue?vue&type=script&lang=ts"
export * from "./confirmDialog.vue?vue&type=script&lang=ts"
import style0 from "./confirmDialog.vue?vue&type=style&index=0&id=4d47fa45&prod&lang=css"
import style1 from "./confirmDialog.vue?vue&type=style&index=1&id=4d47fa45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d47fa45",
  null
  
)

export default component.exports